/* ============================================================
   Afterglow — anchor links
   This theme scrolls an inner .page-wrapper, not the window, so
   the browser's own jump to #installation or #faq does nothing.
   This finds the element's real scroll container and moves that
   instead, honouring scroll-margin-top so the heading clears the
   sticky header.

   Arriving with a hash in the URL lands instantly (smooth would
   mean watching the page crawl past on every visit, and browsers
   suspend smooth scrolling in background tabs anyway). Clicking a
   link on the page you are already on glides.
   ============================================================ */

(function () {
  if (window.__agAnchors) return;
  window.__agAnchors = true;

  var userMoved = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, function () { userMoved = true; }, { passive: true });
  });

  function scrollerFor(el) {
    for (var n = el.parentElement; n; n = n.parentElement) {
      var s = getComputedStyle(n);
      if (/(auto|scroll)/.test(s.overflowY) && n.scrollHeight > n.clientHeight + 2) return n;
    }
    return document.scrollingElement || document.documentElement;
  }

  function jump(hash, smooth) {
    if (!hash || hash.length < 2) return false;
    var el;
    try { el = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { return false; }
    if (!el) return false;

    var sc = scrollerFor(el);
    var offset = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
    var isRoot = sc === document.scrollingElement || sc === document.documentElement;
    var scTop = isRoot ? 0 : sc.getBoundingClientRect().top;
    var target = Math.max(0, sc.scrollTop + el.getBoundingClientRect().top - scTop - offset);

    if (smooth) {
      sc.scrollTo({ top: target, behavior: 'smooth' });
    } else {
      // The theme sets scroll-behavior: smooth globally, which would
      // animate even a plain assignment. Turn it off for this one move.
      var prev = sc.style.scrollBehavior;
      sc.style.scrollBehavior = 'auto';
      sc.scrollTop = target;
      sc.style.scrollBehavior = prev;
    }
    return true;
  }

  function arrive() {
    if (userMoved) return;
    jump(location.hash, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrive);
  } else {
    arrive();
  }

  // Images settling can shift the page, so re-aim once everything is in.
  window.addEventListener('load', function () {
    arrive();
    setTimeout(arrive, 300);
  });

  window.addEventListener('hashchange', function () { jump(location.hash, true); });

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a || a.target === '_blank') return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (!url.hash || url.pathname !== location.pathname || url.host !== location.host) return;
    if (!document.getElementById(decodeURIComponent(url.hash.slice(1)))) return;
    e.preventDefault();
    userMoved = true;
    if (history.pushState) history.pushState(null, '', url.hash);
    jump(url.hash, true);
  });

  window.__agAnchorJump = jump;
})();
